var _path, _g, _path2, _path3, _path4, _path5, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBadge(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7626 0.586826V10.0599C12.7626 10.2834 12.6419 10.4884 12.4561 10.5815L6.61354 13.6833C6.46492 13.7578 6.28843 13.7578 6.13982 13.6833L0.306526 10.5815C0.120753 10.479 0 10.2834 0 10.0599V0.586826C0 0.270126 0.241506 0 0.538743 0H12.2239C12.5211 0 12.7626 0.260812 12.7626 0.586826Z",
    fill: "#6FCD9E"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_16312_10608)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.5556 1.80768V9.42711C11.5556 9.62272 11.4534 9.79038 11.2955 9.87422L6.58615 12.3706C6.45611 12.4358 6.30749 12.4358 6.17745 12.3706L3.92959 11.1783L1.46809 9.87422C1.31018 9.79038 1.20801 9.6134 1.20801 9.42711V1.80768C1.20801 1.52824 1.41236 1.30469 1.67244 1.30469H11.0819C11.342 1.30469 11.5463 1.52824 11.5463 1.80768H11.5556Z",
    fill: "url(#paint0_radial_16312_10608)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5556 1.80768V9.42711C11.5556 9.62272 11.4534 9.79038 11.2955 9.87422L6.58615 12.3706C6.45611 12.4358 6.30749 12.4358 6.17745 12.3706L3.92959 11.1783L1.46809 9.87422C1.31018 9.79038 1.20801 9.6134 1.20801 9.42711V1.80768C1.20801 1.52824 1.41236 1.30469 1.67244 1.30469H11.0819C11.342 1.30469 11.5463 1.52824 11.5463 1.80768H11.5556Z",
    stroke: "white",
    strokeWidth: 0.3,
    strokeMiterlimit: 10
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.2364 2.35712C10.4222 2.35712 10.5708 2.52479 10.5708 2.72971V8.97056C10.5708 9.11028 10.4965 9.24069 10.385 9.29657L6.53024 11.3365C6.53024 11.3365 6.43735 11.3738 6.38162 11.3738C6.32589 11.3738 6.27945 11.3644 6.233 11.3365L4.39384 10.3585L2.3782 9.28726C2.26674 9.22206 2.19243 9.10097 2.19243 8.96125V2.72971C2.19243 2.52479 2.34105 2.35712 2.52682 2.35712H10.2271M10.2271 2.31055H2.53611C2.32247 2.31055 2.15527 2.49684 2.15527 2.72039V8.96125C2.15527 9.1196 2.23887 9.25932 2.36891 9.33383L4.38456 10.405L6.22371 11.3831C6.27945 11.411 6.33518 11.4203 6.39091 11.4203C6.44664 11.4203 6.50237 11.411 6.55811 11.3831L10.4129 9.34315C10.5429 9.27795 10.6265 9.12891 10.6265 8.97056V2.72971C10.6265 2.50616 10.4593 2.31986 10.2457 2.31986L10.2271 2.31055Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M4.62576 0L0 4.63872V1.93746L1.93204 0H4.62576Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.45,
    d: "M7.02224 0L0 7.04192V5.37458L5.35957 0H7.02224Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M6.38122 3.50195L6.92925 5.19723C6.98498 5.37421 7.14289 5.48599 7.32866 5.48599H9.1028L7.67234 6.52923C7.52372 6.63169 7.46799 6.8273 7.52372 6.99497L8.07175 8.69024L6.6413 7.647C6.49268 7.54453 6.29762 7.54453 6.149 7.647L4.71854 8.69024L5.26657 6.99497C5.32231 6.81799 5.26658 6.63169 5.11796 6.52923L3.6875 5.48599H5.46164C5.63812 5.48599 5.80532 5.36489 5.86105 5.19723L6.40908 3.50195H6.38122Z",
    fill: "#FFD94B"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_16312_10608",
    x: 0.677617,
    y: 0.964785,
    width: 11.4084,
    height: 12.1746,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 0.19
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.19
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.4 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_16312_10608"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_16312_10608",
    result: "shape"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_16312_10608",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.3818 6.86557) scale(5.35957 5.37458)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7261DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#705FDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#6A58DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#604CDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.95,
    stopColor: "#513BDF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4931DF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBadge);
export default __webpack_public_path__ + "static/media/badge.61becffafaab16f3a4ffda6f9c575719.svg";
export { ForwardRef as ReactComponent };